
import { useRoute } from 'vue-router'
import { ref, onBeforeMount } from 'vue'
import { getOfficialEnjoySongVersionInfo } from '@/services/songs'
import config from '@/config'
import { songType, songSheetType } from '@/utils/dataMap/song'
import UploadSongConfig from '../enjoy-song-form/UploadSongConfig.vue'

export default {
  name: 'VersionDetail',
  components: {
    UploadSongConfig
  },
  setup () {
    const route = useRoute()
    console.log(1, route.params)
    const formState = ref({
      tags: []
    })
    onBeforeMount(async () => {
      formState.value = await getOfficialEnjoySongVersionInfo(route.params.versionId)
    })

    return {
      history,
      formState,
      config,
      songType,
      songSheetType
    }
  }
}
